import React, { useState, useEffect } from 'react';
import type { CSSProperties } from 'react';
import { Fab, Box } from '@mui/material';
import NavigationIcon from '@mui/icons-material/Navigation';
import InputIcon from "../../../../../../assets/icons/text.svg";
import TextareaIcon from "../../../../../../assets/icons/textarea.svg";
import CheckboxIcon from "../../../../../../assets/icons/checkbox.svg";
import RadioIcon from "../../../../../../assets/icons/radio.svg";
import type { DragSourceMonitor } from 'react-dnd';
import { useDrag } from 'react-dnd';
import { ItemTypes } from './ItemTypes';

const style: CSSProperties = {
  backgroundColor: '#ECEDFC',
  width: "46%",
  borderRadius: "12px",
  margin: "10px 2%",
  minHeight: "120px",
  boxShadow: "none",
}

export interface BoxProps {
  name: string
}

interface DropResult {
  allowedDropEffect: string
  dropEffect: string
  name: string
}

export const BoxGrid = (props: any) => {
  const generateId = React.useId();
  const fieldDetails = [
    {
      "name": "text",
      "type": "text",
      "required": false,
      "placeholder": "placeholder",
      "icon": InputIcon,
    },
    {
      "name": "select",
      "type": "select",
      "required": false,
      "options": "options",
      "placeholder": "placeholder",
      "icon": InputIcon,
    },
    {
      "name": "radio",
      "type": "radio",
      "required": false,
      "options": "options",
      "placeholder": "placeholder",
      "icon": RadioIcon,
    },
    {
      "name": "textarea",
      "type": "textarea",
      "required": false,
      "placeholder": "placeholder",
      "icon": TextareaIcon,
    },
    {
      "name": "checkbox",
      "type": "checkbox",
      "required": false,
      "options": "options",
      "placeholder": "placeholder",
      "icon": CheckboxIcon,
    }
  ];

  const [{ opacity }, drag] = useDrag(
    () => ({
      type: ItemTypes.BOX,
      item: { name: props.name },
      end(item, monitor) {
        const dropResult = monitor.getDropResult() as DropResult;
        if (item && dropResult) {
          let alertMessage = ''
          const isDropAllowed = dropResult.allowedDropEffect === 'any' || dropResult.allowedDropEffect === dropResult.dropEffect
          if (isDropAllowed) {
            const isCopyAction = dropResult.dropEffect === 'copy';
            const actionName = isCopyAction ? 'copied' : 'moved';
            alertMessage = `You ${actionName} ${item.name} into ${dropResult.name}!`;
            let result = fieldDetails.filter((obj: any) => obj.type == item.name);
            props.setItems((prevItems: any) => [...prevItems, { ...result[0], id: `${generateId}-${prevItems.length}`, text: item.name }]);
          } else {
            alertMessage = `You cannot ${dropResult.dropEffect} an item into the ${dropResult.name}`
          }
          //alert(alertMessage);
        }
      },
      collect: (monitor: DragSourceMonitor) => ({
        opacity: monitor.isDragging() ? 0.4 : 1,
      }),
    }),
    [props?.name],
  )

  return ( 

      <Fab ref={drag as any} size="large" disableRipple variant="extended" style={{ ...style, opacity }}>
        <Box style={{display: "flex", alignItems: "center",}}>
          {<img src={props.icon} style={{ margin: 4, height: 26, width: 26 }} />}
          {props?.name}
        </Box>
      
      </Fab>

    
  )
}
